// extracted by mini-css-extract-plugin
export default {"bns3_subscriptionContainer":"SubscriptionContainer_bns3_subscriptionContainer__jRJhl"};